module.exports = {"name":"Type Name","tag":{"id":"0","text":"noTag"},"tagBit":{"id":"99","text":"noBit"},"boolConfig":{"trueMsg":"True","trueColor":{"id":"danger","text":"Danger"},"falseMsg":"False","falseColor":{"id":"success","text":"Success"}}}


//////////////////
// WEBPACK FOOTER
// ./src/views/site/Developer/DeveloperOverviewRender/Components/Data/DataTypesBool.json
// module id = 352
// module chunks = 0